import React, { useEffect, useState } from 'react';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import InfoContent from 'components/commercetools-ui/atoms/info-section-with-image';
import SectionWithBanner from 'components/commercetools-ui/atoms/experience-centre-banner';
import ImageTextContent from 'components/commercetools-ui/atoms/image-text-content';
import TimelineComponent from 'components/commercetools-ui/atoms/timeline';
import Typography from 'components/commercetools-ui/atoms/typography';
import WhiteOverlay from 'components/commercetools-ui/atoms/overlay/white-overlay';

interface OurStoryProps {
  data: any;
}
type componentType = {
  section_with_image_text: any;
  section_with_banner: any;
  multiple_info_section: any;
  section_with_heading_description: any;
};
const OurStoryPage: React.FC<OurStoryProps> = ({ data }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the timeout duration as needed
  }, []);

  // Find sections dynamically
  const headingDescriptionSection = data?.sections?.find(
    (section: componentType) => section?.section_with_heading_description
  );
  
  const timelineSection = data?.sections?.find(
    (section: componentType) => section?.multiple_info_section
  );

  return (
    <>
      {loading && <WhiteOverlay />}
      <div className="w-full">
        <div className="hidden px-24 pb-8 pt-16 md:!block md:px-28 lg:px-48 xl:px-60 2xl:pl-60 2xl:pr-80 3xl:pl-804">
          <Breadcrumb Separator={<ChevronRightIcon className="mt-0 w-16" />} listClassName="!gap-x-16">
            <Link link={'/'}>
              <HomeIcon className="mt-6 w-20" />
            </Link>
            <span className="text-12 font-normal leading-4 text-[#666]">Our Story</span>
          </Breadcrumb>
        </div>

        <div className="flex flex-col gap-y-48 md:gap-y-50">
          {data?.sections?.map((component: componentType, index: number) => (
            <div key={index}>
              {component?.section_with_banner && (
                <SectionWithBanner data={component?.section_with_banner} />
              )}
              {component?.section_with_image_text && (
                <div className="xl:px-80 3xl:px-180">
                  <InfoContent
                    data={component?.section_with_image_text}
                    index={index}
                    totalSections={data?.sections?.length}
                  />
                </div>
              )}
            </div>
          ))}

          {/* Render heading description and timeline dynamically */}
          {(headingDescriptionSection || timelineSection) && (
            <div className="lg:flex items-center pb-48 -mt-48">
              {headingDescriptionSection?.section_with_heading_description && (
                <div className="px-24 xl:pl-90 2xl:pl-180">
                  <Typography
                    as="h1"
                    className="text-28 text-center lg:text-left font-semibold leading-[3rem] text-primary-black drop-shadow-sm max-w-[40rem] 3xl:text-40"
                  >
                    {headingDescriptionSection.section_with_heading_description.title}
                  </Typography>
                </div>
              )}
              {timelineSection?.multiple_info_section && (
                <div className="lg:w-[44rem] lg:h-[14rem] 3xl:h-[20rem] flex-1 lg:px-48 xl:px-90"> <style>
                {`@media (min-width: 1024px) and (max-width: 1920px) {
                  .ReactModal__Content.ReactModal__Content--after-open.border-transparent.focus\\:border-transparent.focus\\:ring-0.focus\\:outline-none.relative {
                    max-width: 800px !important;
                  }
                }
                `}
              </style>
                  <TimelineComponent data={timelineSection.multiple_info_section} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OurStoryPage;
